export const initailstates = null;

export const dreducer = (states, action) => {
  if (action.type === "DLOGIN") {
    return action.payload;
  }
  return states;
};
